import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";

/**
 * Local-part tag that lets a Redo employee install as a Shopify employee for
 * testing, e.g. `someone+shopifyemployee@redo.com`. Only honored on Redo
 * domains so merchants can't opt into Shopify-store behavior themselves.
 */
const SHOPIFY_EMPLOYEE_TAG = "shopifyemployee";

export function isShopifyEmail(email: string | undefined): boolean {
  const normalized = email?.toLowerCase();
  if (!normalized) {
    return false;
  }
  if (normalized.endsWith("@shopify.com")) {
    return true;
  }
  const localPart = normalized.split("@")[0] ?? "";
  return (
    isRedoEmailAddress(normalized) && localPart.includes(SHOPIFY_EMPLOYEE_TAG)
  );
}
